import React from 'react';
import classNames from 'classnames';
import CardHeader from './CardHeader';
import CardBody from './CardBody';
import CardFooter from './CardFooter';
import type { CardProps } from '../../../types/components/Card';

const Card = ({
  variant = 'default',
  fullWidth,
  title,
  titleWeight,
  subtitle,
  icon,
  actions,
  noDivider,
  plain,
  headingAs,
  bodyPadding = 'default',
  footer,
  footerProps,
  className,
  headerClassName,
  bodyClassName,
  footerClassName,
  wrapBody = true,
  dataCy,
  children,
  ...rest
}: CardProps) => (
  <section
    className={classNames(
      'bwp-card',
      { [`bwp-card--${variant}`]: variant !== 'default' },
      { 'bwp-card--full-width': fullWidth },
      className,
    )}
    data-cy={dataCy}
    {...rest}
  >
    <CardHeader
      title={title}
      titleWeight={titleWeight}
      subtitle={subtitle}
      icon={icon}
      actions={actions}
      noDivider={noDivider}
      plain={plain}
      as={headingAs}
      className={headerClassName}
    />

    {children != null &&
      (wrapBody ? (
        <CardBody padding={bodyPadding} className={bodyClassName}>
          {children}
        </CardBody>
      ) : (
        children
      ))}

    {footer && (
      <CardFooter {...footerProps} className={footerClassName}>
        {footer}
      </CardFooter>
    )}
  </section>
);

export default Card;